import { getArrayTableColumns } from "./arrayTableModel";
import { hasSchemaType } from "./schemaFormModel";

export function createArrayTableRule(schemaFormProvider, sfPathProvider) {
	return function arrayTable(name, schema, options) {
		if(!hasSchemaType(schema, "array")
			|| !hasSchemaType(schema.items, "object")
			|| !schema.items.properties) {
			return undefined;
		}

		const field = schemaFormProvider.stdFormObj(name, schema, options);
		field.type = "array-table";
		field.key = options.path;
		field.startEmpty = true;
		field.itemTitle = schema.items.title || "Entry";
		field.tableColumns = getArrayTableColumns(schema);

		options.lookup[sfPathProvider.stringify(options.path)] = field;
		return field;
	};
}

export function arrayTableAddOn(
	schemaFormDecoratorsProvider,
	sfBuilderProvider,
	schemaFormProvider,
	sfPathProvider
) {
	const rule = createArrayTableRule(schemaFormProvider, sfPathProvider);
	schemaFormProvider.defaults.array.unshift(rule);

	schemaFormDecoratorsProvider.defineAddOn(
		"bootstrapDecorator",
		"array-table",
		"./array-table.html",
		[
			sfBuilderProvider.builders.sfField,
			sfBuilderProvider.builders.ngModelOptions,
			sfBuilderProvider.builders.ngModel,
			sfBuilderProvider.builders.condition
		]
	);
}
